import React, { FC } from 'react';
import classnames from 'classnames';
import { Avatar } from '@src/components/Avatar';
import { Image } from '../Image';
import { AvatarWithInfoProps } from './props';
import './styles.scss';

export const AvatarWithInfo: FC<AvatarWithInfoProps> = ({
  wrapperClassName,
  name,
  subTitle,
  avatarProps,
  imageProps,
}) => {
  return (
    <div className={classnames('user-info', wrapperClassName)}>
      <div className="user-info__images">
        <div className="user-info__avatar">
          <Avatar {...avatarProps} />
        </div>

        {imageProps && <Image {...imageProps} className="user-info__company-logo" />}
      </div>
      <div className="user-info__details">
        <p>{name}</p>
        <p>{subTitle}</p>
      </div>
    </div>
  );
};
